
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  configurationNewHeadline: {
    id: "ConfigurationNew.headline",
    defaultMessage: "Please give your configuration details:",
  }, 
  configurationNewFormNameError: {
    id: "ConfigurationNewFormName.error",
    defaultMessage: "Name is required.",
  }, 
  configurationNewFormNameLabel: {
    id: "ConfigurationNewFormName.label",
    defaultMessage: "Name",
  }, 
  configurationNewFormNamePlaceholder: {
    id: "ConfigurationNewFormName.placeholder",
    defaultMessage: "Name",
  }, 
  configurationNewFormPricingsAccessoriesError: {
    id: "ConfigurationNewFormPricingsAccessories.error",
    defaultMessage: "Time period is required.",
  }, 
  configurationNewFormPricingsAccessoriesLabel: {
    id: "ConfigurationNewFormPricingsAccessories.label",
    defaultMessage: "Time Period Accessories",
  }, 
  configurationNewFormPricingsAccessoriesPlaceholder: {
    id: "ConfigurationNewFormPricingsAccessories.placeholder",
    defaultMessage: "Please select...",
  }, 
  configurationNewFormPricingsWashbasinError: {
    id: "ConfigurationNewFormPricingsWashbasin.error",
    defaultMessage: "Time period is required.",
  }, 
  configurationNewFormPricingsWashbasinLabel: {
    id: "ConfigurationNewFormPricingsWashbasin.label",
    defaultMessage: "Time Period Washbasin",
  }, 
  configurationNewFormPricingsWashbasinPlaceholder: {
    id: "ConfigurationNewFormPricingsWashbasin.placeholder",
    defaultMessage: "Please select...",
  }, 
});

export default MESSAGES;